import type {
  CreateHostTutorBookingRequest,
  TutorBookingOccurrenceRequest,
  TutorLessonOption,
  TutorSessionType,
} from '../models/Tutor';
import { isAtTeacherSession, tutorSessionNeedsRoom } from './tutorSessionType';

export function isOfflineLessonOption(
  option: Pick<TutorLessonOption, 'sessionType'> | null | undefined,
): boolean {
  return isAtTeacherSession(option?.sessionType);
}

export function buildHostTutorWalkInBookingRequest(params: {
  tutorId: string;
  lessonOptionId: string;
  startTime: string;
  sessionType?: TutorSessionType | null;
  roomId?: string | null;
  userId?: string | null;
  title?: string | null;
  phoneNumber?: string | null;
  sendSms?: boolean | null;
  paymentMethod?: CreateHostTutorBookingRequest['paymentMethod'];
  occurrences?: TutorBookingOccurrenceRequest[] | null;
}): CreateHostTutorBookingRequest {
  const {
    tutorId,
    lessonOptionId,
    startTime,
    sessionType,
    roomId,
    userId,
    title,
    phoneNumber,
    sendSms,
    paymentMethod,
    occurrences,
  } = params;
  const request: CreateHostTutorBookingRequest = {
    tutorId,
    lessonOptionId,
    startTime,
    paymentMethod,
  };
  if (occurrences && occurrences.length > 1) {
    request.occurrences = occurrences;
  }
  if (tutorSessionNeedsRoom(sessionType) && roomId?.trim()) {
    request.roomId = roomId.trim();
  }
  const trimmedUserId = userId?.trim();
  if (trimmedUserId) {
    request.userId = trimmedUserId;
  }
  const trimmedTitle = title?.trim();
  if (trimmedTitle) {
    request.title = trimmedTitle;
  }
  const trimmedPhone = phoneNumber?.trim();
  if (trimmedPhone) {
    request.phoneNumber = trimmedPhone;
  }
  if (sendSms != null) {
    request.sendSms = sendSms;
  }
  return request;
}

export function validateHostTutorWalkInBooking(params: {
  tutorId?: string | null;
  lessonOptionId?: string | null;
  startTime?: string | null;
  sessionType?: TutorSessionType | null;
  roomId?: string | null;
}): string | null {
  if (!params.tutorId?.trim()) return 'tutorId';
  if (!params.lessonOptionId?.trim()) return 'lessonOptionId';
  if (!params.startTime?.trim()) return 'startTime';
  return null;
}
